import {combineReducers} from 'redux';
import appState from './appState';
import signalrState from './signalrState';
import availableLabwareState from './availableLabwareState';
import cardState from './cardState';
import reportState from './reportState';
import labwareState from './labwareState';
import modalState from './modalState';
import userManagementState from './userManagementState';
import modalSetTrayIDState from './modalSetTrayIDState';
import typedModalState from './typedModalState';
import trayCalibrationState from './trayCalibrationState';
import sessionState from './sessionState';
import tipState from './tipState';
import protocolState from './protocolState';
import runtimeState from './runtimeState';
import plateTypeEditorState from './plateTypeEditorState';
import protocolEditorState from './protocolEditorState';
import configState from './configState';
import normalizationState from './normalizationState';
import temporaryState from './temporaryState';
import colorState from './colorState';
import undoRedoState from './undoRedoState';
import aboutState from './aboutState';
import licenseState from './licenseState';
import wizardState from './wizardState';
import protocolExplorerState from './protocolExplorerState';
import reteachPlateState from './reteachPlateState';
import userPreferenceState from './userPreferenceState';
import virtualTrayState from './virtualTrayState';
import taskListState from './taskListState';
import headState from './headState';
import humidifierState from './humidifierState';
import bannerState from './bannerState';
import plateRecognitionState from './plateRecognitionState';
import instrumentState from './instrumentState';

const rootReducer = combineReducers({
  appState,
  signalrState,
  availableLabwareState,
  cardState,
  reportState,
  labwareState,
  modalState,
  userManagementState,
  modalSetTrayIDState,
  typedModalState,
  trayCalibrationState,
  sessionState,
  tipState,
  protocolState,
  runtimeState,
  plateTypeEditorState,
  protocolEditorState,
  configState,
  normalizationState,
  temporaryState,
  colorState,
  undoRedoState,
  aboutState,
  licenseState,
  wizardState,
  protocolExplorerState,
  reteachPlateState,
  userPreferenceState,
  virtualTrayState,
  taskListState,
  headState,
  humidifierState,
  bannerState,
  plateRecognitionState,
  instrumentState,
});

export default rootReducer;
